//https://medium.com/@BrodaNoel/conditional-rendering-in-react-and-jsx-the-solution-7c80beba1e36
const Conditional = (props) => {
    return (
        !!props.if && props.children
    );
};

export default Conditional;


// WEBPACK FOOTER //
// ./src/core/Conditional.js